import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getUserByEmail } from "../Firebase/Firebase.utils";

function UserAvatar({ email, size = "md" }) {
  const [user, setUser] = useState({});
  const [initials, setInitials] = useState("");
  const [loading, setLoading] = useState(true);

  // Size classes mapping
  const sizeClasses = {
    sm: "w-7 h-7 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-14 h-14 text-base",
  };

  // Generate random background color based on email
  const generateColor = (email) => {
    const colors = [
      "bg-blue-500",
      "bg-green-500",
      "bg-yellow-500",
      "bg-red-500",
      "bg-purple-500",
      "bg-pink-500",
      "bg-indigo-500",
      "bg-teal-500",
      "bg-orange-500",
    ];

    let hash = 0;
    for (let i = 0; i < email.length; i++) {
      hash = email.charCodeAt(i) + ((hash << 5) - hash);
    }

    return colors[Math.abs(hash) % colors.length];
  };

  // Get user data and generate initials
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getUserByEmail("users", email);
        setUser(userData);

        // Generate initials from displayName
        if (userData.displayName) {
          const names = userData.displayName.split(" ");
          if (names.length === 1) {
            setInitials(names[0].charAt(0).toUpperCase());
          } else {
            setInitials(
              (
                names[0].charAt(0) + names[names.length - 1].charAt(0)
              ).toUpperCase()
            );
          }
        } else {
          // Fallback to email
          setInitials(email.charAt(0).toUpperCase());
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setInitials(email.charAt(0).toUpperCase());
        setLoading(false);
      }
    };

    if (email) {
      fetchUserData();
    }
  }, [email]);

  if (loading) {
    return (
      <div
        className={`${sizeClasses[size]} rounded-full bg-gray-200 animate-pulse`}
      ></div>
    );
  }

  const colorClass = generateColor(email);

  return (
    <div>
      <Link to={`/profile/${user.id}`}>
        {user.profilePhoto ? (
          <div className={`${sizeClasses[size]} rounded-full overflow-hidden`}>
            <img
              src={user.profilePhoto}
              alt={user.displayName || email}
              className="w-full h-full object-cover"
            />
          </div>
        ) : (
          <div
            className={`${sizeClasses[size]} rounded-full ${colorClass} flex items-center justify-center text-white font-medium`}
          >
            {initials}
          </div>
        )}
      </Link>

      {size !== "sm" && user.displayName && (
        <div className="text-gray-600 font-medium text-xs capitalize mt-1 text-center truncate max-w-[60px]">
          {user.displayName.toLowerCase()}
        </div>
      )}
    </div>
  );
}

export default UserAvatar;
